<template>
  <div>
    <div class="user-avatar">
      <div class="avatar-details">
        <div class="avatar-details">
          <h5>{{ currentUser.userfirstName }} {{ currentUser.userlastName }}</h5>
          <p>{{ currentUser.usersecurity }}</p>
        </div>
      </div>
    </div>
    <nav class="nav-drawer">
      <div class="nav-section">
        <h2 class="section-title">MAIN</h2>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link :to="{ name : 'TransactionManager' }" class="nav-link">
              <font-awesome-icon icon="home" class="nav-icon" />
              DashBoard
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name : 'KazangInitialization' }" class="nav-link">
              <font-awesome-icon icon="fa-solid fa-key" class="nav-icon" />
              Reset Password
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name : 'UserManagment' }" class="nav-link">
              <font-awesome-icon icon="fa-solid fa-users" class="nav-icon" />
              User Managment
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name : 'FormManagement' }" class="nav-link">
              <font-awesome-icon icon="fa-solid fa-users" class="nav-icon" />
              Form Managment
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name : 'Settings' }" class="nav-link">
              <font-awesome-icon icon="fa-solid fa-key" class="nav-icon" />
              Settings
            </router-link>
          </li>
          <li class="accordion-body logout-item"  @click="userLogout">
            <font-awesome-icon icon="fa-solid fa-lock" class="nav-icon"/>
            User Logout
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  computed:{
    currentUser() {
      const user = this.$store.getters.getCurrentUser || {};
      return {

        firstName: user.userfirstName,
        lastName: user.userlastName,
        security: user.usersecurity,
        ...user
      };
    }
  },
  beforeMount() {
    this.fetchLogo()
  },
  methods : {
    userLogout(){
      this.$store.commit('logOutInfo');
      sessionStorage.removeItem('session');
      return this.$router.push({ name : `login` })
    },
    fetchLogo() {
      const user = JSON.parse(localStorage.getItem('current_user'));
      console.log(user)
      // this.$store.dispatch('getCompanyLogo', 5).then(imageUrl => {
      //   this.companyLogo = imageUrl;
      // });
    }
  }
}
</script>
<style scoped lang="scss">
.user-avatar {
  display: inline-flex;
  width: 100%;
  background: url('@/assets/KazangBanner.png') fixed;
  background-size: 100% 140px;
  color: white;
  min-height: 140px;
  background-color: #656262;
  background-blend-mode: soft-light;

  .avatar {
    background: #40434A;
    min-width: 80px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .avatar-details {
    width: 100%;
    padding: 5px 5px 5px 10px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;

    h5, p {
      margin: 0;
    }

    p {
      font-size: 15px;
      color: #ffffff;
      font-weight: 400;

      &:nth-child(3) {
        color: #ffffff;
        font-weight: 600;
      }
    }

  }
}

.nav-drawer {
  padding: 1rem;
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
}

.nav-section {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0.5rem 0;

  &:hover {
    .section-title {
      color: #007bff;
    }
  }
}

.section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin: 0.25rem 0;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  color: #666;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9375rem;
  transition: all 0.2s ease;

  &:hover {
    color: #007bff;
    background-color: #f8f9fa;
  }

  &.router-link-active {
    color: #007bff;
    background-color: #e7f1ff;
  }
}

.nav-icon {
  width: 1rem;
  margin-right: 0.75rem;
}

.toggle-icon {
  font-size: 0.75rem;
  color: #666;
  transition: transform 0.2s ease;
}

.logout-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  color: #666;
  background-color: #f8f9fa;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9375rem;
  transition: all 0.2s ease;
}

.logout-item:hover {
  color: #007bff;
}


</style>